module.exports = __webpack_public_path__ + "ENG_NarratorVideo_2-51166a39ade1e9c13d344eca28fe8cdf.png";